import type { Action, Subject } from '@account-manager/shared';
import { Can as CaslCan } from '@casl/react';
import type { ReactNode } from 'react';
import { useAbility } from './useAbility.js';

export function Can({ I, a, children }: { I: Action; a: Subject; children: ReactNode }) {
  const ability = useAbility();
  return (
    <CaslCan I={I} a={a} ability={ability as never}>
      {() => <>{children}</>}
    </CaslCan>
  );
}
